/**
 * Create a slug for use as part of a subdomain (contains only letters, numbers
 * and hyphen). The resulting string will not start or end with a hyphen and
 * will not contain multiple consecutive hyphens.
 */
export default function slugify(input: string): string {
  return input
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
}
